var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  viewBox: "0 0 14 14",
  role: "img"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 14,
  fill: "#FF3CA0",
  rx: 2
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M7.39 3.52c1.46 0 2.31.79 2.78 1.63l-1.22.6q-.069.043-.133.09l-.008-.018c-.3-.456-.797-.859-1.412-.859-1.105 0-1.901.88-1.901 2.02s.796 1.997 1.9 1.997c.616 0 1.092-.367 1.413-.826l.004-.029.137.065 1.22.59c-.47.83-1.32 1.64-2.78 1.64-2.01 0-3.56-1.4-3.56-3.45 0-2.06 1.55-3.45 3.56-3.45"
}))));
export default SvgContent;